import { searchProdutoForWhatsApp } from '../actions/newOrder';

export async function buildCartItemsFromAbandonedItens(itens, loja) {
	const cartItems = [];
	for (const item of itens || []) {
		if (item.produto) {
			cartItems.push({
				_id: String(item.produto),
				title: item.nome || '',
				price: Number(item.precoUnitario) || 0,
				picture: null,
				quantity: Math.max(1, Number(item.quantidade) || 1),
			});
			continue;
		}
		const name = (item.nome || '').trim();
		if (!name) continue;
		const found = await searchProdutoForWhatsApp(name, loja);
		if (found.length > 0) {
			const product = found[0];
			cartItems.push({
				_id: product._id,
				title: product.titulo || product.title || name,
				price: Number(item.precoUnitario) || Number(product.preco) || 0,
				picture: product.fotos?.[0] ?? product.picture,
				quantity: Math.max(1, Number(item.quantidade) || 1),
			});
		}
	}
	return cartItems;
}
